import 'ui-core/widgets/profile-menu/js/profile-menu';

(function () {
    UX.dropblockUl.vPort = 'screen-md';

    UX.dropblockUl.on.dropdownBuild = function (elem) {
        var $dropdownContainer = null,
            $activeTab = null;
        if (UX.dropBlock) {
            UX.dropBlock.init();
        }
        elem.wrap('<div class="profile-menu--dropBlock" data-db-parent-of="dbTab-profile-menu"></div>');
        $dropdownContainer = elem.closest('.profile-menu--dropBlock');
        $activeTab = UX.dropblockUl.get.activeTab(elem);
        $dropdownContainer.prepend(
            '<a href="#" data-db-target-for="dbTab-profile-menu"><span>' +
                $activeTab.text() +
                '</span><i class="icon-arrow_down pull-right" aria-hidden="true"></i></a>'
        );
        elem.attr('data-db-target-of', 'dbTab-profile-menu');
    };
})(UX);
